<script>
	import { createEventDispatcher } from "svelte";
	import { uiText } from "../lib/uiText.js";
	import {
		doc,
		getDoc,
		// collection,
		// addDoc,
		// setDoc,
		// updateDoc,
		// arrayUnion,
		// onSnapshot,
		// deleteField,
		// serverTimestamp,
		// increment,
		// query,
		// limit,
		// orderBy,
	} from "firebase/firestore";
	import QrCode from "./QRCode.svelte";

	const dispatch = createEventDispatcher();

	// export let auth;
	export let db;
	export let lang;
	export let loader;
	let ui = uiText(lang);
	$: lang,
		(ui = uiText(lang)),
		dispatch("setLang", { lang: lang, prefset: true });
	$: loader, dispatch("loader", loader), (ui = uiText(lang));
	$: screen, dispatch("screen", screen);

	let screen = "input"; //input or showcase
	let mode = "gid"; //gid or free

	let openSet = {
		gid:
			sessionStorage.getItem("latestGID") === null
				? ""
				: sessionStorage.getItem("latestGID"),
	};

	let codeValue = false;
	let squareSize = 560;
	let colorDark = "#093986";
	let colorLight;

	let size = 16;
	let logo_size = 16;
	let hashtag_size = 16;

	let gameName = "";
	let hashtag = "#ПравимГрадскиИгри";

	async function handleOpenGame() {
		const openGameRef = doc(db, "games", openSet.gid);
		const checkSnap = await getDoc(openGameRef);

		if (checkSnap.exists()) {
			console.log("Game exists!");
			console.log("Loading game...");
			console.log(checkSnap.data());
			sessionStorage.setItem("latestGID", openSet.gid);
			let data = checkSnap.data();

			codeValue = data.purchaseLink;
			gameName = data.name;
		} else {
			console.log("A game with this GID doesn't exist!");
		}
	}
</script>

<!--  -->
<!--  -->
<!--  -->

{#if screen == "input"}
	<p class="mt-6 uppercase">VG Panel</p>
	<h1>QR Display</h1>
	{#if mode == "gid"}
		<label for="open-gid">GID:</label>

		<input
			type="text"
			name="open-gid"
			maxlength="10"
			id="open-gid"
			bind:value={openSet.gid}
			placeholder="Open Game ID"
			title="Game ID of the game you want to open"
		/>
		<label for="hash">#:</label>
		<input
			type="text"
			name="hash"
			id="hash"
			bind:value={hashtag}
			placeholder="#ВътрешенГлас"
			title="#Hashtag to be shown at the bottom"
		/>

		<p>QR Content: {codeValue ? codeValue : "Unset - Open a game to change"}</p>
		<button on:click={handleOpenGame}
			><i class="fa-solid fa-folder-open" data-position="left" />Open Game</button
		>
		<button
			on:click={() => {
				mode = "free";
			}}>Free Mode</button
		>
	{:else}
		<label for="input-free">QR Content:</label>

		<input
			type="text"
			name="input-free"
			id="input-free"
			bind:value={codeValue}
			placeholder="vutreshenglas.com"
			title="QR Content"
		/>
		<label for="hash">#:</label>
		<input
			type="text"
			name="hash"
			id="hash"
			bind:value={hashtag}
			placeholder="#ВътрешенГлас"
			title="#Hashtag to be shown at the bottom"
		/>
		<button
			on:click={() => {
				mode = "gid";
			}}>GID Mode</button
		>
	{/if}
	{#if codeValue.length > 1}
		<button on:click={() => (screen = "showcase")}
			><i class="fa-solid fa-qrcode" data-position="left" />Showcase</button
		>
	{/if}
{:else if screen == "showcase"}
	<div
		class="flex flex-wrap min-h-screen p-12 -mx-4 -mt-8 sm:grid place-content-center"
		id="showcase"
		style={"font-size:" + size + "px"}
	>
		<div
			class="grid self-start col-span-2 place-content-center"
			style={"font-size:" + logo_size + "px"}
		>
			<img
				class="max-w-full p-4 h-[10em] mb-12"
				src={lang === "bg" ? "/img/svg/logo-bg.svg" : "/img/svg/logo-en.svg"}
				alt={ui.game.footer.vendor}
			/>
		</div>
		<div class="grid">
			<div class="p-4 bg-white qr place-self-center w-full sm:max-w-[30vw]">
				<QrCode {codeValue} {squareSize} />
			</div>
		</div>
		{#if mode == "gid"}
			<div class="m-12 grid place-content-center">
				<!-- <h1 class=" opacity-80">Scan the code to join</h1> -->
				<h1 class=" opacity-80">{ui.panel.scan_qr_pre}</h1>

				<h1 class="text-6xl" style="text-wrap:balance">
					{gameName ? gameName : "Unset - Open a game to change"}
				</h1>
				<!-- <h1 class=" opacity-80">and play with your friends!</h1> -->
				<h1 class=" opacity-80">{ui.panel.scan_qr_post}</h1>
			</div>
		{/if}
		<div
			class="grid content-end justify-center col-span-2"
			style={"font-size:" + hashtag_size + "px"}
		>
			<h1 class="font-light text-teal">{hashtag}</h1>
		</div>
	</div>
	<div
		class="fixed bottom-0 left-0 p-4 text-blue-100 bg-white opacity-0 hover:opacity-100"
	>
		<i class="mr-4 fa-solid fa-text-height" />
		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-square-plus"
			on:click={() => (size = size + 1)}
		/>
		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-square-minus"
			on:click={() => (size = size - 1)}
		/>
		|
		<i class="mx-4 fa-brands fa-blogger-b" />
		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-square-plus"
			on:click={() => (logo_size = logo_size + 1)}
		/>
		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-square-minus"
			on:click={() => (logo_size = logo_size - 1)}
		/>

		|
		<i class="mx-4 fa-solid fa-hashtag" />
		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-square-plus"
			on:click={() => (hashtag_size = hashtag_size + 1)}
		/>
		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-square-minus"
			on:click={() => (hashtag_size = hashtag_size - 1)}
		/>

		|
		<i class="mx-4 fa-solid fa-qrcode" />
		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-square-pen"
			on:click={() => (screen = "input")}
		/>
	</div>
{/if}

<style>
	#showcase {
		grid-template-columns: auto 1fr;
		grid-template-rows: 1fr auto 1fr;
	}
	#showcase .qr {
		box-shadow: #093986 10px 10px 0;
	}
	#showcase h1 {
		font-size: 3em;
		line-height: normal;
	}
	#showcase h1.text-6xl {
		font-size: 5em;
		line-height: normal;
		filter: drop-shadow(10px 10px 0px #093986);
		text-transform: uppercase;
		font-weight: 900;
	}
</style>
